import { CommunityVisibility } from "client/Api/Communities/community";
import { FontIconName, IconAndText } from "client/Components";
import { ReactElement } from "react";
import { localize } from "client_legacy/ndaw/culture";
import { never } from "client_legacy/ndaw/errors";

export type VisibilityLabelProps = {
	visibility: CommunityVisibility;
};

export const VisibilityLabel = (props: VisibilityLabelProps): ReactElement => {
	const {
		visibility
	} = props;

	const display: VisibilityDisplay = getVisibilityDisplay(visibility);

	return (
		<IconAndText
			text={display.text}
			trackingId="visibility"
		>
			<IconAndText.Icon
				value={{
					kind: "font",
					name: display.icon,
					color: "primary"
				}}
			/>
		</IconAndText>
	);
};
VisibilityLabel.displayName = "VisibilityLabel";

export type VisibilityDisplay = {
	icon: FontIconName;
	text: string;
};

export function getVisibilityDisplay(visibility: CommunityVisibility): VisibilityDisplay {
	switch (visibility) {
		case CommunityVisibility.Public:
			return {
				icon: "globe",
				text: localize("_Public")
			};
		case CommunityVisibility.Private:
			return {
				icon: "lock",
				text: localize("_Private")
			};
		case CommunityVisibility.Hidden:
			return {
				icon: "eye-slash",
				text: localize("_Hidden")
			};
		default:
			never(visibility);
	}
}
